import { ReactNode } from 'react';
import clsx from 'clsx';
import { t } from 'i18next';

import { SectionTitle } from 'shared/ui/section-title';
import { SectionInfo } from 'shared/ui/section-info';
import { SeeAllButton, SEE_ALL_ROUTES } from 'shared/ui/buttons';
import { ContentWrapper, TopLinedContainer } from 'shared/ui/layout';

import {
  TEST_STREAM_SECTION_INFO,
  TEST_STREAM_SECTION_INFO_NO_SEE_ALL,
} from './constants';
import styles from './styles.module.scss';

export type StreamPreviewLayoutProps = {
  children: ReactNode;
  showSeeAllButton: boolean;
};

export const StreamPreviewLayout = ({
  children,
  showSeeAllButton,
}: StreamPreviewLayoutProps) => {
  const tooltipText = showSeeAllButton
    ? TEST_STREAM_SECTION_INFO
    : TEST_STREAM_SECTION_INFO_NO_SEE_ALL;

  return (
    <TopLinedContainer
      classNames={clsx('layout-context-compact', styles.streamSection)}
      id="stream_section"
    >
      <div className="d-flex flex-column flex-sm-row align-items-center justify-content-between rhythm-mb-2">
        <div className="d-flex align-items-center mb-2 mb-sm-0">
          <SectionTitle classNames="m-0">{t('Stream')}</SectionTitle>
          <SectionInfo
            messageText={tooltipText}
            sectionName="stream"
            tooltipClassnames={clsx(styles.streamInfoTooltip, {
              [styles.noSeeAllInfoTooltip]: !showSeeAllButton,
            })}
          />
        </div>
        {showSeeAllButton && (
          <SeeAllButton
            navigateTo={SEE_ALL_ROUTES.STREAM}
            sectionName={SEE_ALL_ROUTES.STREAM}
          />
        )}
      </div>
      <ContentWrapper>{children}</ContentWrapper>
    </TopLinedContainer>
  );
};
